// extracted by mini-css-extract-plugin
export default {"root":"ContactDisplay_root__ep3nm"};